import { Http } from 'src/shared/services/Http';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { Language } from '../models/language';

export class LanguageService {
    constructor(private http: Http, private toastNotificationsService: ToastNotificationsService) {}

    public async fetchLanguages(): Promise<Language[] | void> {
        try {
            return await this.http.GET_UNAUTHENTICATED<Language[]>('languages/');
        } catch {
            this.toastNotificationsService.renderErrorToast("Couldn't fetch a list of languages");
        }
    }
}
